//---- components ---------
//---- mixins -------------
//---- services -----------
import { ajaxService } from '@/app/services';
//---- other --------------
import URL from '../common/URL.js';
//---- 3rd-parties --------

class AuthoringService {

    solutionView(caseId) {
        return ajaxService.postWithParams(URL.viewCaseDetailsUrl, { caseId })
    }

    commitValuesToServer(editedValuesJsonData) {
        return ajaxService.postUrlEncodedData(URL.updateGivenAttribUrl, editedValuesJsonData)
    }

    commitValuesToServerMCM(editedValuesJsonData) {
        return ajaxService.postUrlEncodedData(URL.updateGivenAttribMCMUrl, editedValuesJsonData)
    }

    buildParam(transition, token) {
        const param = {};
        if (transition)
            param.transition = transition;
        if (token)
            param.token = token;
        return param;
    }

    validateUpdateCase(transition, token) {
        return ajaxService.postWithParams(URL.validateUpdateCaseUrl, this.buildParam(transition, token));
    }

    updateCase(transition, token) {
        return ajaxService.postWithParams(URL.updateCaseUrl, this.buildParam(transition, token));
    }

    validateUpdateCaseMCM(transition, token) {
        return ajaxService.postWithParams(URL.validateMultipleCasesUrl, this.buildParam(transition, token));
    }

    updateCaseMCM(transition, token) {
        return ajaxService.postWithParams(URL.updateMultipleCasesUrl, this.buildParam(transition, token));
    }

    modifyExistingCase(force) {
        if (force)
            return ajaxService.postWithParams(URL.modifyExistingCaseUrl, {force: true});
        else 
            return ajaxService.post(URL.modifyExistingCaseUrl);
    }
        
    modifyExistingCasesMCM(force) {
        if (force)
            return ajaxService.postWithParams(URL.modifyExistingCasesMCMUrl, {force: true});
        else 
            return ajaxService.post(URL.modifyExistingCasesMCMUrl);
    }

    // get the attributes info for the given viewId (authoring tab)
    switchTab(viewId) {
        return ajaxService.getWithParams(URL.getGivenViewAttributesUrl, { viewId });
    }

    // get the attributes info for the given viewId (authoring tab) in Multi-Case-Management mode
    switchTabMCM(viewId) {
        return ajaxService.getWithParams(URL.getGivenViewAttributesMCMUrl, { viewId });
    }

    spellCheck() {
        return ajaxService.get(URL.spellCheckUrl);
    }

    // return attribute value for a full view
    getAttributesValueSet(viewId) {
        return ajaxService.postWithParams(URL.getAttributesValueSetUrl, { viewId });
    }

    // return attribute value for a full view MCM
    getAttributesValueSetMCM(viewId) {
        return ajaxService.postWithParams(URL.getAttributesValueSetMCMUrl, { viewId });
    }

    // return attribute value for a single attribute
    getAttribValueSet(requestData) {
        // todo: can we have some type of assertion on the content of requestData????
        // requestData should contain viewId and slotId
        return ajaxService.postWithParams(URL.getAttribValueSetUrl, requestData);
    }

    // return attribute value for a single attribute for MCM
    getAttribValueSetMCM(requestData) {
        // todo: can we have some type of assertion on the content of requestData????
        // requestData should contain viewId and slotId
        return ajaxService.postWithParams(URL.getAttribValueSetMCMUrl, requestData);
    }

    getUpdateApprovals() {
        return ajaxService.get(URL.getUpdateApprovalsUrl);
    }

    getCreateApprovals() {
        return ajaxService.get(URL.getCreateApprovalsUrl);
    }

    authoring() {
        return ajaxService.post(URL.authoringUrl);
    }

    authoringMCM() {
        return ajaxService.post(URL.authoringMCMUrl);
    }

    // feedback action

    addComments(comments) {
        const formData = new FormData();
        formData.append("comments", comments)
        return ajaxService.postData(URL.feedbackUrl, formData);
    }

    deleteComment(commentId) {
        const formData = new FormData();
        formData.append("commentId", commentId)
        return ajaxService.postData(URL.deleteComment, formData);
    }

    rateSolution(rating) {
        return ajaxService.postWithParams(URL.feedbackUrl, { rating });
    }
    
    sendFeedback(rating, comments, approved) {
        // add rating, comments and approved if they are not undefined
        return ajaxService.postData(URL.feedbackUrl, { ...rating && {rating}, 
                                                        ...comments && {comments}, 
                                                        ...approved && {approved}
                                                    });
    }

    addToFavorites(requestData) {
        return ajaxService.postWithParams(URL.addToFavoritesUrl, requestData);
    }

    removeFromFavorites(caseIds) {
        return ajaxService.postWithParams(URL.removeFromFavoritesUrl, { caseIds });
    }

    solutionAccepted(accepted) {
        return ajaxService.postWithParams(URL.solutionAcceptedUrl, { accepted });
    }

    mailCase(requestData) {
        return ajaxService.postUrlEncodedData(URL.mailCaseUrl, requestData);
    }

    getUpdatedCase() {
        return ajaxService.get(URL.updatedCaseUrl);
    }

    backAction(params) {
        return ajaxService.postData(
            URL.previousUrl,
            params
        );
    }

    // ping server on every 30 second if user in authoring mode
    pingServer(params) {
        return ajaxService.postData(URL.authoringServerPingUrl, params);
    }

    // compare solution
    viewCasesForComparison() {
        return ajaxService.get(URL.viewCasesForComparisonUrl);
    }

    loadCasesForComparison() {
        return ajaxService.get(URL.loadCasesForComparisonUrl)
    }

    // auto-tag
    getAutoTagSuggestions() {
        return ajaxService.get(URL.autoTagUrl);
    }

    acceptAutoTag(params) {
        return ajaxService.postData(URL.acceptAutoTagUrl, params);
    }

    closeAutoTagWindow() {
        return ajaxService.get(URL.closeAutoTagurl);
    }

    // solution create
    createNewFromSolution() {
        return ajaxService.get(URL.createNewFromSolutionUrl)
    }

    createNewFromSearch() {
        return ajaxService.get(URL.createNewFromSearchUrl)
    }

    translateCase() {
        return ajaxService.get(URL.translateCaseUrl)
    }

    deleteCase(token) {
        return ajaxService.postWithParams(URL.deleteCaseUrl, { token: token });
    }

    async electronicSignature(securityUrl, username, password, transactionId) {
        return ajaxService.postWithParams(
          securityUrl,
          { transactionId },
          { 
            headers: {
              Authorization: "Basic " + window.btoa(username+":"+password)
            }, 
            withCredentials: true,
          }
        );
    }

    deleteMultipleCases(token) {
        return ajaxService.postWithParams(URL.deleteMultipleCasesUrl, { token: token });
    }

    deleteExistingCases(token) {
        return ajaxService.postWithParams(URL.deleteExistingCasesUrl, { token: token });
    }

    deleteAutoTagSuggesion(params) {
        return ajaxService.postData(URL.deleteAutoTagurl, params);
    }

}

export default new AuthoringService();
